<template>
    <div class="modal right fade trader-info addfltrmodal" id="trader-info" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{filterData.id ? 'Edit Bidding Strategy' : 'Add Bidding Strategy'}}</h5>
            <div class="float-right">
              <button type="button" class="close"  @click="$emit('close')"><span aria-hidden="true">&times;</span></button>
            </div>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-row">
                <div class="form-group col-md-3 required">
                      <label for="inputEmail4">Name</label>
                      <input  type="text" class="form-control" id="inputEmail4" placeholder="Name"  v-model="filterData.name" >
                </div>
                <div class="form-group col-md-3 required">
                    <label for="inputEmail4">Product</label>
                    <select class="form-control" id="exampleFormControlSelect1" placeholder="Please select"  v-model="filterData.offeringTypeId">
                        <option value="1">MUNICIPAL</option>
                        <option value="2">CORPORATE</option>                  
                    </select>
                </div>
                <div class="form-group col-md-2 required">
                    <label for="inputEmail4">Box Type</label>
                    <select class="form-control" id="exampleFormControlSelect1" placeholder="Please select"  v-model="filterData.boxType">
                        <option value="GREY">GREY</option>
                        <option value="BLACK">BLACK</option>                  
                    </select>
                </div>
                <div class="form-group col-md-2">
                    <label for="inputEmail4">Min Coupon %</label>
                    <input  type="number" class="form-control" id="inputEmail4" placeholder="minCoupon"  v-model="filterData.minCoupon" >
                </div>
                <div class="form-group col-md-2">
                    <label for="inputEmail4">Max Coupon %</label>
                    <input  type="number" class="form-control" id="inputEmail4" placeholder="Max Coupon"  v-model="filterData.maxCoupon" >
                </div>
               </div>
               <div class="form-row">
                <div class="form-group col-md-3">
                    <label for="inputEmail4">Min Maturity Date</label>
                    <datepicker v-model="filterData.minMaturityDate" placeholder="mm/dd/yyyy" typeable name="Min Maturity Date" format="MM/dd/yyyy" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                </div>
                <div class="form-group col-md-3">
                    <label for="inputEmail4">Max Maturity Date</label>
                    <datepicker v-model="filterData.maxMaturityDate" placeholder="mm/dd/yyyy" typeable name="Max Maturity Date" format="MM/dd/yyyy" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker> 
                </div>
                <div class="form-group col-md-3">
                    <label for="inputEmail4">Min Call Date</label>
                    <datepicker v-model="filterData.minCallDate" placeholder="mm/dd/yyyy" typeable name="Min Call Date" format="MM/dd/yyyy" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker> 
                </div>
                <div class="form-group col-md-3">
                    <label for="inputEmail4">Max Call Date</label>
                    <datepicker v-model="filterData.maxCallDate" placeholder="mm/dd/yyyy" typeable name="Max Call Date" format="MM/dd/yyyy" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker> 
                </div>
                <div class="form-group col-md-3">
                    <label for="inputEmail4">Max Bid Price</label>
                    <input  type="number" class="form-control" id="inputEmail4" placeholder="Max Bid Price"  v-model="filterData.maxPriceLimit" >
                </div>
                <div class="form-group col-md-2">
                        <label for="inputEmail4">Min Qty</label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Min Quantity"  v-model="filterData.minQtyCutoff" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Max Qty</label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Max Quantity"  v-model="filterData.maxQtyCutoff" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Price Type</label>
                        <select class="form-control" id="exampleFormControlSelect1" placeholder="Please select"  v-model="filterData.priceType">
                        <option value="DYNAMIC">DYNAMIC</option>   
                        <option value="STATIC">STATIC</option>

                    </select>
                        
                    </div>
                    <div class="form-group col-md-3 required">
                        <label for="inputEmail4">Static Price</label>
                        <input @input="handleInput" :disabled="filterData.priceType == 'DYNAMIC'"  type="number" class="form-control" id="inputEmail4" placeholder="Static Price"  v-model="filterData.staticPrice" >
                    </div>
              </div>
              <h4 class="d-flex text-uppercase" style="font-weight: 900;color: #0087d4 !important;">IDC Price</h4>
              <hr class="mt-0 mb-0">
              <div class="form-row">
                <div class="form-group col-md-4" v-if="filterData.idcAction">
                  <br>
                    <label for="inputEmail4">
                      Bidding Price Difference <i style="color: orange;font-size: 18px;" class="fas fa-info-circle info" data-toggle="tooltip" v-bind:title="'Bid Price Difference to IDC'"></i> 
                    </label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                          <div class="input-group-text" style="height: 39px;">
                            <select v-model="filterData.idcAction" class="form-select form-select-sm" aria-label="Add or subtract">
                              <option value="ADDITION">+</option>
                              <option value="DEDUCTION">-</option>
                            </select>
                          </div>
                        </div>
                        <input :disabled="filterData.priceType == 'STATIC'" type="number" class="form-control" id="inputEmail4" placeholder="IDC Diff"  v-model="filterData.idcValue" >
                      </div>
                </div>
              </div>
              <h4 class="d-flex text-uppercase" style="font-weight: 900;color: #0087d4 !important;">Interdealer Tolerance Check</h4>
              <hr class="mt-0 mb-0">
              <br>
              <div class="form-row">  
                <!-- <div class="form-group col-md-3">
                    <label for="inputEmail4">Min Trade Date</label>
                    <datepicker v-model="filterData.minTradeDate" placeholder="mm/dd/yyyy" typeable name="Min Call Date" format="MM/dd/yyyy" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker> 
                </div>
                <div class="form-group col-md-3">
                    <label for="inputEmail4">Max Trade Date</label>
                    <datepicker v-model="filterData.maxTradeDate" placeholder="mm/dd/yyyy" typeable name="Max Call Date" format="MM/dd/yyyy" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker> 
                </div> -->
                <div class="form-group col-md-4">
                    <label for="inputEmail4">Number of Past Trade Days <i style="color: orange;font-size: 18px;" class="fas fa-info-circle info" data-toggle="tooltip" v-bind:title="'Number of last business days to be considered'"></i> </label>
                    <input :disabled="filterData.priceType == 'STATIC'"  type="number" class="form-control" id="inputEmail4" oninput="validity.valid || (value='');" min="1"  placeholder="Days Ago "  v-model="filterData.daysAgo" >
                </div>
                <div class="form-group col-md-3">
                    <label for="inputEmail4">Trades Count <i style="color: orange;font-size: 18px;" class="fas fa-info-circle info" data-toggle="tooltip" v-bind:title="'Number of Latest Inter Dealer Trades to be considered'"></i></label>
                    <input :disabled="filterData.priceType == 'STATIC'"  type="number" class="form-control" id="inputEmail4" placeholder="Trades Count"  v-model="filterData.tradesCount" >
                </div>
                <div class="form-group col-md-2">
                    <label for="inputEmail4">Quantity <i style="color: orange;font-size: 18px;" class="fas fa-info-circle info" data-toggle="tooltip" v-bind:title="'Quantity Range to be considered from the inter dealer trades'"></i></label>
                    <input :disabled="filterData.priceType == 'STATIC'"  type="number" class="form-control" id="inputEmail4" placeholder="Quantity"  v-model="filterData.quantity" >
                </div>
                <div class="form-group col-md-3">
                    <label for="inputEmail4">BID Price Tolerance <i style="color: orange;font-size: 18px;" class="fas fa-info-circle info" data-toggle="tooltip" v-bind:title="'Accepted Tolerance for Bid price from Inter Dealer Price'"></i></label>
                    <input :disabled="filterData.priceType == 'STATIC'"  type="number" class="form-control" id="inputEmail4" placeholder="BID Price Tolerance"  v-model="filterData.idcDifference" >
                </div>
              </div>
              
              <div class="form-row">
                <div class="form-group col-md-4">
                  <h4 class="d-flex text-uppercase" style="font-weight: 900;color: #0087d4 !important;">MMD Tolerance Check</h4>
                    <hr class="mt-0 mb-0">
                    <br>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                          <label for="inputEmail4">MMD Difference <i style="color: orange;font-size: 18px;" class="fas fa-info-circle info" data-toggle="tooltip" v-bind:title="'Accepted Tolerance for Bid price YTW to MMD curve'"></i></label>
                          <input :disabled="filterData.priceType == 'STATIC'"  type="number" class="form-control" id="inputEmail4" placeholder="MMD Difference"  v-model="filterData.mmdIdcDifference" >
                      </div>
                      <div class="form-group col-md-6">
                          <label for="inputEmail4">Minimum YTW <i style="color: orange;font-size: 18px;" class="fas fa-info-circle info" data-toggle="tooltip" v-bind:title="'Minimum YTW required for the Bid Price'"></i></label>
                          <input :disabled="filterData.priceType == 'STATIC'"  type="number" class="form-control" id="inputEmail4" placeholder="Minimum YTW"  v-model="filterData.minimumYield" >
                      </div>
                    </div>
                </div>
                <div class="form-group col-md-4">
                  <h4 class="d-flex text-uppercase" style="font-weight: 900;color: #0087d4 !important;">OFFERINGS Price difference</h4>
                    <hr class="mt-0 mb-0">
                    <br>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                          <label for="inputEmail4">Offerings Price Difference <i style="color: orange;font-size: 18px;" class="fas fa-info-circle info" data-toggle="tooltip" v-bind:title="'Bid price has to lower by Offer price by minimum the value set'"></i></label>
                          <input :disabled="filterData.priceType == 'STATIC'"  type="number" class="form-control" id="inputEmail4" placeholder="Offerings Price Difference"  v-model="filterData.arbsPriceDifference" >
                      </div>
                    </div>
                </div>
                <div class="form-group col-md-4">
                  <h4 class="d-flex text-uppercase" style="font-weight: 900;color: #0087d4 !important;">Price Adjustment factor</h4>
                    <hr class="mt-0 mb-0">
                    <br>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                          <label for="inputEmail4">Price Adjustment factor <i style="color: orange;font-size: 18px;" class="fas fa-info-circle info" data-toggle="tooltip" v-bind:title="'Adjustment to BID price if tolerance check failed'"></i></label>
                          <input :disabled="filterData.priceType == 'STATIC'"  type="number" class="form-control" id="inputEmail4" placeholder="Price Adjustment factor"  v-model="filterData.priceAdjustmentFactor" >
                      </div>
                    </div>
                </div>
              </div>
              
              
              <hr class="mt-0 mb-0">
              <br>
              <div class="form-row">
                <div class="form-group col-md-8">
                        <label for="inputEmail4">Municipal Security Types</label><a class="allStates" @click="clearMuncipalType()"><i class="fa fa-trash"></i> Clear</a>
                        <div class="radio-buttons mt-1">
                            <label class="mr-3">
                                <input type="radio" v-model="isMunicipalSecurityTypesIn" value="exclude">
                                Exclude
                            </label>
                            <label>
                                <input type="radio" v-model="isMunicipalSecurityTypesIn" value="include">
                                Include
                            </label>
                        </div>
                        <multiselect
                            :disabled="!isMunicipalSecurityTypesIn"
                            v-model="filterData.municipalSecurityTypes"
                            placeholder="Select"
                            label="name"
                            track-by="value"
                            :options="municipalSecurityTypes"
                            :multiple="true"
                          ></multiselect>
                    </div>
                    <div class="form-group col-md-2 mt-4">
                        <label for="inputEmail4">RatingSP From </label>
                        <select @change="checkRatingRangeisValid()" class="form-control" id="exampleFormControlSelect"  v-model="ratingFrom">
                            <option value>Please select</option>
                            <option
                            v-for="spfrom in spRatingConstants"
                            :key="spfrom"
                            v-bind:value="spfrom"
                          >{{spfrom}}</option>
                          </select>
                        
                    </div>
                    <div class="form-group col-md-2 mt-4">
                        <label for="inputEmail4">RatingSP To</label>
                       
                        <select @change="checkRatingRangeisValid()" class="form-control" id="exampleFormControlSelect1"  v-model="ratingTo">
                            <option value>Please select</option>
                            <option
                            v-for="sp in spRatingConstants"
                            :key="sp"
                            v-bind:value="sp"
                            
                          >{{sp}}</option>
                          </select>
                       
                    </div>
              </div>
              <div class="form-row">
                  <div class="form-group col-md-4">
                    <label for="inputLast">States</label> <a class="allStates" @click="selectAllState()"><i class="fa fa-angle-right"></i> {{isStateSelectAll ? 'Select' : 'Unselect'}} All</a>
                      <div class="flex-container">
                        <div v-for="state in stateCodes" :key="state.code" @click="selectState(state)" class="cursor-pointer states" :class="{ statesAtive: state.isActive }">
                          {{ state.short }}
                        </div>
                      </div>
                  </div>
                  <div class="form-group col-md-4 attributes">
                        <label for="inputEmail4">Attributes</label><a class="allStates" @click="clearAllAttributes()"><i class="fa fa-trash"></i> Clear All</a>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col" class="sort text-left"></th>
                              
                              <th scope="col" class="sort text-center">Exclude</th>
                              <th scope="col" class="sort text-center">Include</th>
                              <th scope="col" class="sort text-center">Only If</th>
                            </tr>
                          </thead>
                          <tbody class="list no-cursor attr-table">
                            <tr>
                              <td>PreRefund</td>

                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.preRefund" name="excludePreRefund" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.preRefund" name="includePreRefund" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.preRefund" name="includePreRefund" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>escrowed</td>
              
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.escrowed" name="excludeescrowed" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.escrowed" name="includeescrowed" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.escrowed" name="includeescrowed" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>insured</td>
                          
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.insured" name="excludeinsured" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.insured" name="includeinsured" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.insured" name="includeinsured" value="onlyif">
                                </div>
                              </td>
                            </tr>
                          
                            <tr>
                              <td>taxable</td>
                           
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.taxable" name="excludetaxable" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.taxable" name="includetaxable" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.taxable" name="includetaxable" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>AMT</td>
                             
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.amt" name="excludeAMT" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.amt" name="includeAMT" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.amt" name="includeAMT" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>bank Q</td>
                           
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.bankQ" name="excludebankQ" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.bankQ" name="includebankQ" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.bankQ" name="includebankQ" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>callable</td>
                     
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.callable" name="excludecallable" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.callable" name="includecallable" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.callable" name="includecallable" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>putable</td>
                         
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.putable" name="excludeputable" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.putable" name="includeputable" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.putable" name="includeputable" value="onlyif">
                                </div>
                              </td>
                            </tr>
                           
                            <tr> 
                              <td>sinking Fund</td>
                              
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.sinkingFund" name="excludesinkingFund" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.sinkingFund" name="includesinkingFund" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.sinkingFund" name="includesinkingFund" value="onlyif">
                                </div>
                              </td>
                            </tr>
                           
                            <tr>
                              <td>zero Coupon</td>
                            
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.zeroCoupon" name="excludezeroCoupon" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.zeroCoupon" name="includezeroCoupon" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.zeroCoupon" name="includezeroCoupon" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>below Min</td>
                             
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.belowMin" name="excludebelowMin" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.belowMin" name="includebelowMin" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.belowMin" name="includebelowMin" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            
                            <tr>
                              <td>green Bonds</td>
                           
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.greenBonds" name="excludegreenBonds" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.greenBonds" name="includegreenBonds" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.greenBonds" name="includegreenBonds" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>technical Default</td>
                           
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.technicalDefault" name="excludetechnicalDefault" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.technicalDefault" name="includetechnicalDefault" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.technicalDefault" name="includetechnicalDefault" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>Irregular Settlement</td>
                           
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.irregularSettlement" name="irregularSettlement" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.irregularSettlement" name="irregularSettlement" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.irregularSettlement" name="irregularSettlement" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            
                          </tbody>
                        </table>
                  </div> 
                  <div class="form-group col-md-4 insurer" v-if="filterData.insured === 'onlyif' || filterData.insured === 'include'">
                    <label for="inputLast">Insurers </label>
                    <a class="allStates" @click="clearInsurers()"><i class="fa fa-trash"></i> Clear</a>
                      <div class="flex-container">
                        <table class="table align-items-center table-flush table-hover bidtbl">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col" class="sort text-left"></th>
                              <th scope="col" class="sort text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="insurersType" name="insurersType" value="exclude">
                                  Exclude</div>
                              </th>
                              <th scope="col" class="sort text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="insurersType" name="insurersType" value="include">
                                  Include</div>
                              </th>
                            </tr>
                          </thead>
                          </table>
                      </div>
                      <div class="form-group" v-if="insurersType">
                        <multiselect
                            v-model="insurersValue"
                            placeholder="Select"
                            :options="bondinsurer"
                            :multiple="true"
                          ></multiselect>
                      </div>
                  </div>
                  <div class="form-group col-md-8 insurer">
                    <label for="inputLast">Proceeds</label>
                    <a class="allStates" @click="clearProceeds()"><i class="fa fa-trash"></i> Clear</a>
                      <div class="flex-container">
                        <table class="table align-items-center table-flush table-hover bidtbl">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col" class="sort text-left"></th>
                              <th scope="col" class="sort text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="proceedsType" name="proceedsType" value="exclude">
                                  Exclude</div>
                              </th>
                              <th scope="col" class="sort text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="proceedsType" name="proceedsType" value="include">
                                  Include</div>
                              </th>
                            </tr>
                          </thead>
                          </table>
                      </div>
                      <div class="form-group" v-if="proceedsType">
                        <multiselect
                            v-model="proceedsValue"
                            placeholder="Select"
                            label="name"
                            track-by="value"
                            :options="purposeConstants"
                            :multiple="true"
                          ></multiselect>
                      </div>

                  </div>
              </div>    
               
              <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                <p v-if="errors.length">
                    <ul>
                    <li class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</li>
                    </ul>
                </p>
                <div class="modal-footer bid">
                    <button type="button" class="btn btn-secondary"  @click="$emit('close')">Close</button>
                    <button v-if="!filterData.id" :disabled="loading" type="button" class="btn btn-primary" @click="addFilter()">ADD</button>
                    <button v-if="filterData.id" :disabled="loading" type="button" class="btn btn-primary" @click="updateFilter()">UPDATE</button>
                </div>
            </form>    
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
import authService from "@/authService";
import config from "@/config";
import Datepicker from "vuejs-datepicker";
import stateConstants from "@/stateConstants";
import moodyConstants from "@/moodyRatingConstants";
import spRatingConstants from "@/spRatingConstants";
import bondinsurer from "@/bondinsurerConstants";
import purposeConstants from "@/purposeConstants";

export default {
  name: "sendBidModal",
  components: {
    Datepicker
  },
  props: ["selectedfilter"],
  data() {
    return {
      loading: false,
      filterData: {
        idcAction : "DEDUCTION",
        priceType : "DYNAMIC"
      },
      errors: [],
      stateConstantsCopy: stateConstants,
      moodyConstants:moodyConstants,
      spRatingConstants:spRatingConstants,
      stateCodes : [],
      isStateSelectAll : true,
      ratingFrom : "",
      ratingTo : "",
      municipalSecurityTypes : [
          { name: "Unknown", value: "UNKNOWN" },
          { name: "Special assessment", value: "SPECIAL_ASSESSMENT" },
          { name: "Double barreled", value: "DOUBLE_BARRELED" },
          { name: "Lease-rental", value: "LEASE_RENTAL" },
          { name: "Fuel/vehicle tax", value: "FUEL_VEHICLE_TAX" },
          { name: "Unlimited G.O.", value: "UNLIMITED_G_O_" },
          { name: "Limited G.O.", value: "LIMITED_G_O_" },
          { name: "Other", value: "OTHER" },
          { name: "Revenue", value: "REVENUE" },
          { name: "Sales/excise tax", value: "SALES_EXCISE_TAX" },
          { name: "Tax allocation/increment", value: "TAX_ALLOCATION_INCREMENT" },
          { name: "U.S. government-backed", value: "U_S_GOVERNMENT_BACKED" },
          { name: "Tobacco state appropriated", value: "TOBACCO_STATE_APPROPRIATED" },
          { name: "Tobacco settlement non-appropriated", value: "TOBACCO_SETTLEMENT_NON_APPROPRIATED" },
          { name: "Federal grant", value: "FEDERAL_GRANT" },
          { name: "Cigarette tax", value: "CIGARETTE_TAX" },
          { name: "Hotel tax", value: "HOTEL_TAX" },
          { name: "Miscellaneous tax", value: "MISCELLANEOUS_TAX" },
          { name: "Personal income tax", value: "PERSONAL_INCOME_TAX" },
          { name: "Pilot", value: "PILOT" }
        ],
        insurersType : "",
        proceedsType : "",
        insurersValue : [],
        proceedsValue : [],
        bondinsurer : [...new Set(bondinsurer.map(item => item.Abbreviation))],
        purposeConstants : purposeConstants,
        isMunicipalSecurityTypesIn : ""


    };
  },
  methods: {
    clearInsurers(){
      this.insurersType = "";
      this.insurersValue = [];
    },
    clearProceeds(){
      this.proceedsType = "";
      this.proceedsValue = [];
    },
    clearMuncipalType(){
      this.isMunicipalSecurityTypesIn = "";
      this.filterData.municipalSecurityTypes = [];
    },
    addFilter() {
      let isValid = this.checkForm();
      if (isValid) {
        this.loading = true;
        var addData = this.filterData;
            addData.minMaturityDate = addData.minMaturityDate ? this.moment(addData.minMaturityDate).format("YYYY-MM-DD") : null;               
            addData.maxMaturityDate = addData.maxMaturityDate ? this.moment(addData.maxMaturityDate).format("YYYY-MM-DD") : null;               
            addData.minCallDate = addData.minCallDate ? this.moment(addData.minCallDate).format("YYYY-MM-DD") : null;               
            addData.maxCallDate = addData.maxCallDate ? this.moment(addData.maxCallDate).format("YYYY-MM-DD") : null; 
            addData.minTradeDate = addData.minTradeDate ? this.moment(addData.minTradeDate).format("YYYY-MM-DD") : null;               
            addData.maxTradeDate = addData.maxTradeDate ? this.moment(addData.maxTradeDate).format("YYYY-MM-DD") : null;                
            addData.maxPriceLimit = addData.maxPriceLimit  ? addData.maxPriceLimit : null;                
            addData.status = "ACTIVE";
            addData.traderId = authService.getUser().id;
            addData.states =  this.stateCodes.filter(user => user.isActive === true).map(state => state.short)
            if(this.ratingFrom && !this.ratingTo){
              this.ratingTo = this.spRatingConstants[this.spRatingConstants.length - 1];
            }
            if(this.ratingTo && !this.ratingFrom){
              this.ratingFrom = this.spRatingConstants[0];
            }
            addData.ratingSP = this.getRangeOfRatings(this.ratingFrom,this.ratingTo);
            addData.municipalSecurityTypes = addData.municipalSecurityTypes ? addData.municipalSecurityTypes.map((e) => e.value) : [];
           
            addData.isInsureresIn = this.insurersType === "include" ? true : (this.insurersType === "exclude" ? false : null);
            addData.insurers = this.insurersValue ?  this.insurersValue.map(item => item === "FIREMEN'S INS OF NEWARK/CONTL CAS INS" ? "FIREMEN_S_INS_OF_NEWARK/CONTL_CAS_INS" : item) : [];
            addData.isProceedsIn = this.proceedsType === "include" ? true : (this.proceedsType === "exclude" ? false : null);
            addData.proceeds = this.proceedsValue ? this.proceedsValue.map((e) => e.value) : [];
            addData.isMunicipalSecurityTypesIn = this.isMunicipalSecurityTypesIn === "include" ? true : (this.isMunicipalSecurityTypesIn === "exclude" ? false : null);


            if(addData.insured == 'exclude'){
              addData.isInsureresIn = null;
              addData.insurers = [];
            }
            addData.cognitoSub = authService.getUser().cognitoSub;

            const auth = {
              headers: { "org-token": authService.getOrgToken() },
            };
            this.$http
              .post(config.baseUrlAutoBidder + "/autobidder/calcfilter", addData, auth)
              .then(() => {
                this.loading = false;
                this.$alert("Successfully added", "", "success");
                this.$emit("close");
              })
              .catch(() => {
                this.loading = false;
              });
          }
    },
    updateFilter() {
      let isValid = this.checkForm();
      if (isValid) {
        this.loading = true;
        var addData = this.filterData;
            addData.minMaturityDate = addData.minMaturityDate ? this.moment(addData.minMaturityDate).format("YYYY-MM-DD") : null;               
            addData.maxMaturityDate = addData.maxMaturityDate ? this.moment(addData.maxMaturityDate).format("YYYY-MM-DD") : null;               
            addData.minCallDate = addData.minCallDate ? this.moment(addData.minCallDate).format("YYYY-MM-DD") : null;               
            addData.maxCallDate = addData.maxCallDate ? this.moment(addData.maxCallDate).format("YYYY-MM-DD") : null; 
            addData.minTradeDate = addData.minTradeDate ? this.moment(addData.minTradeDate).format("YYYY-MM-DD") : null;               
            addData.maxTradeDate = addData.maxTradeDate ? this.moment(addData.maxTradeDate).format("YYYY-MM-DD") : null; 
            addData.maxPriceLimit = addData.maxPriceLimit  ? addData.maxPriceLimit : null;                
            addData.traderId = authService.getUser().id;
            addData.states =  this.stateCodes.filter(user => user.isActive === true).map(state => state.short)
            if(this.ratingFrom && !this.ratingTo){
              this.ratingTo = this.spRatingConstants[this.spRatingConstants.length - 1];
            }
            if(this.ratingTo && !this.ratingFrom){
              this.ratingFrom = this.spRatingConstants[0];
            }
            addData.ratingSP = this.getRangeOfRatings(this.ratingFrom,this.ratingTo);
            addData.municipalSecurityTypes = addData.municipalSecurityTypes ? addData.municipalSecurityTypes.map((e) => e.value) : [];

            addData.isInsureresIn = this.insurersType === "include" ? true : (this.insurersType === "exclude" ? false : null);
            addData.insurers = this.insurersValue ?  this.insurersValue.map(item => item === "FIREMEN'S INS OF NEWARK/CONTL CAS INS" ? "FIREMEN_S_INS_OF_NEWARK/CONTL_CAS_INS" : item) : [];
            addData.isProceedsIn = this.proceedsType === "include" ? true : (this.proceedsType === "exclude" ? false : null);
            addData.proceeds = this.proceedsValue ? this.proceedsValue.map((e) => e.value) : [];
            addData.isMunicipalSecurityTypesIn = this.isMunicipalSecurityTypesIn === "include" ? true : (this.isMunicipalSecurityTypesIn === "exclude" ? false : null);


            if(addData.insured == 'exclude'){
              addData.isInsureresIn = null;
              addData.insurers = [];
            }
            addData.cognitoSub = authService.getUser().cognitoSub;

            
            delete addData.createdAt
        const auth = {
          headers: { "org-token": authService.getOrgToken() },
        };
        this.$http
          .put(config.baseUrlAutoBidder + "/autobidder/calcfilter", addData, auth)
          .then(() => {
            this.loading = false;
            this.$alert("Successfully Updated", "", "success");
            this.$emit("close");
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    checkForm() {
      this.errors = [];
      if (!this.filterData.name) {
        this.errors.push("Name is required.");
        return false;
      }
      if (!this.filterData.offeringTypeId) {
        this.errors.push("Product is required.");
        return false;
      }
      if (!this.filterData.boxType) {
        this.errors.push("Box type is required.");
        return false;
      }
      console.log(typeof Number(this.filterData.staticPrice))
      if (this.filterData.priceType == 'STATIC' && (!Number(this.filterData.staticPrice))) {
        this.errors.push("Static price is required.");
        return false;
      }
      
      return true;
    },
    handleInput() {
      if (/^0/.test(this.filterData.staticPrice)) {
        this.filterData.staticPrice = this.filterData.staticPrice.replace(/^0/, "");
      }
    },
    selectAllState(){
      if(this.isStateSelectAll){
        this.stateCodes.map(state => state.isActive = true)
        this.isStateSelectAll = false
      }else{
        this.stateCodes.map(state => state.isActive = false)
        this.isStateSelectAll = true
      }
    },
    selectState(state){
      state.isActive = !state.isActive
    },
    clearAllAttributes() {
      const filters = [
        'preRefund',
        'escrowed',
        'insured',
        'taxable',
        'amt',
        'bankQ',
        'callable',
        'putable',
        'sinkingFund',
        'zeroCoupon',
        'belowMin',
        'greenBonds',
        'technicalDefault',
        'irregularSettlement'

      ];
      for (const filter of filters) {
        this.filterData[filter] = null;
      }
    },
    checkRatingRangeisValid(){
      var stringArry = this.spRatingConstants;
      if(this.ratingFrom && this.ratingTo){
          var startIndex = stringArry.indexOf(this.ratingFrom);
          var endIndex = stringArry.indexOf(this.ratingTo);
          if(startIndex <= endIndex) {
            console.log('Selected range is valid');
          } else {
            this.$alert('From Rating should be lower than to rating',"","error");
            this.ratingFrom = "";
            this.ratingTo = "";
          }
      }

    },
    getRangeOfRatings(datafrom,datato){
      console.log(datafrom,datato)
      var stringArry = this.spRatingConstants
      var startIndex = stringArry.indexOf(datafrom);
      var endIndex = stringArry.indexOf(datato);
      var range = [];
      if(startIndex > endIndex){
        // swap the values
        var temp = startIndex;
        startIndex = endIndex;
        endIndex = temp;
      }
      if(datafrom && datato){
        range = stringArry.slice(startIndex, endIndex + 1);
      }else{
        range = []
      }
      return range;
    },
    setFileds(){
      if (this.selectedfilter){
        this.filterData = this.selectedfilter;
        if(this.selectedfilter.states){
          this.selectedfilter.states.map(code =>{
              this.stateCodes.map(stateObj => {
                  if(stateObj.short == code) stateObj.isActive = true
              })
          });
        }
        if(this.selectedfilter.ratingSP){
          this.ratingFrom = this.selectedfilter.ratingSP[0];
          this.ratingTo =  this.selectedfilter.ratingSP[this.selectedfilter.ratingSP.length - 1];
        }
        if(this.selectedfilter.municipalSecurityTypes){
          let selectedTypes = [];
          this.selectedfilter.municipalSecurityTypes.map(type =>{
            this.municipalSecurityTypes.map(munType =>{
              if(munType.value == type){
                selectedTypes.push(munType)
              }
            })
          })
          this.selectedfilter.municipalSecurityTypes = selectedTypes

        }
        // this.insurersType =  this.selectedfilter.isInsureresIn ? "include" : "exclude";
        if (this.selectedfilter.isInsureresIn === true) {
          this.insurersType = "include";
        } else if (this.selectedfilter.isInsureresIn === false) {
          this.insurersType = "exclude";
        } else {
          this.insurersType = "";
        }
        this.insurersValue = this.selectedfilter.insurers ?  this.selectedfilter.insurers.map(item => item === "FIREMEN_S_INS_OF_NEWARK/CONTL_CAS_INS" ? "FIREMEN'S INS OF NEWARK/CONTL CAS INS" : item) : [];
        if (this.selectedfilter.isProceedsIn === true) {
          this.proceedsType = "include";
        } else if (this.selectedfilter.isProceedsIn === false) {
          this.proceedsType = "exclude";
        } else {
          this.proceedsType = "";
        }
        if(this.selectedfilter.proceeds){
          let selectedPurposeTypes = [];
          this.selectedfilter.proceeds.map(type =>{
            this.purposeConstants.map(purposeType =>{
              if(purposeType.value == type){
                selectedPurposeTypes.push(purposeType)
              }
            })
          })
          this.proceedsValue = selectedPurposeTypes

        }
        if(!this.insurersValue){
          this.insurersType = ""
        }
        if(!this.proceedsValue){
          this.proceedsType = ""
        }
        if (this.selectedfilter.isMunicipalSecurityTypesIn === true) {
            this.isMunicipalSecurityTypesIn = "include";
        }else if (this.selectedfilter.isMunicipalSecurityTypesIn === false) {
            this.isMunicipalSecurityTypesIn = "exclude";
        } 
    }else{
        this.selelctedCusips = [];
    } 
    },

  },
  mounted() {
    console.log(this.selectedfilter)
    if (this.selectedfilter){
        this.filterData = this.selectedfilter;
    }
    this.stateCodes = this.stateConstantsCopy.map(state => ({
                        short: state.short,
                        isActive: false
                      }));
    this.setFileds();

  },
};
</script>
<style scoped>
.modal i {
    margin-right: 2px;
}
 .flex-container{
    display: flex;
    flex-wrap: wrap;
   }
   .flex-container div {
    padding: 5px;
   }
   .flex-container div.active{
    background-color: #006fae;
    color: white;
   }
   .attr-table td{
    text-transform: uppercase;
    padding: 3px;
   }
   .insurer .form-check-input{
    margin-top : 0px !important
   }
   .insurer{
    margin: 0px !important;
   }
</style>